import React, { useState } from 'react';
import { Button, ButtonGroup, ToggleButton } from 'react-bootstrap';
import { pushDataLayer } from '../gtm';

export default function Step5_EstudioOrigen({ formData, setFormData, next, prev }) {
  const { tipoCentro, tipoInstitucion, bachillerato, orientacion5to, orientacion6to } = formData;

  const opcionesBachillerato = [
    'Deportes y recreación',
    'Administración',
    'Informática',
    'Turismo',
    'Construcción',
    'Electrónica',
    'Arte',
    'Gastronomía'
  ];
  const [showOtherBachillerato, setShowOtherBachillerato] = useState(
    Boolean(bachillerato && !opcionesBachillerato.includes(bachillerato))
  );

  const opciones5to = [
    'Humanístico',
    'Científico',
    'Biológico',
    'Artístico'
  ];

  const opciones6to = [
    'Derecho',
    'Economía',
    'Ingeniería',
    'Arquitectura',
    'Medicina',
    'Agronomía',
    'Arte y expresión'
  ];

  const handleCentroChange = (op) => {
    setFormData({
      ...formData,
      tipoCentro: op,
      // si es UTU, fijamos Público; si vuelve a Liceo mantenemos lo anterior
      tipoInstitucion: op === 'UTU' ? 'Público' : tipoInstitucion,
      bachillerato: op === 'UTU' ? bachillerato : '',
      orientacion5to: op === 'Liceo' ? orientacion5to : '',
      orientacion6to: op === 'Liceo' ? orientacion6to : '',
      materiasPendientesSeleccionadas: {}
    });
  };


  return (
    <div className="form-container">
      <h2 className="form-title">¿Cursaste Liceo o UTU?</h2>
      <ButtonGroup className="mb-4">
        {['Liceo', 'UTU'].map((op, idx) => (
          <ToggleButton
            key={op}
            type="radio"
            variant="outline-primary"
            id={`tipoCentro-${idx}`}
            name="tipoCentro"
            value={op}
            checked={tipoCentro === op}
            onChange={() => handleCentroChange(op)}
          >
            {op}
          </ToggleButton>
        ))}
      </ButtonGroup>

      <h2 className="form-title">¿Público o Privado?</h2>
      <ButtonGroup className="mb-4">
        {['Público', 'Privado'].map((op, idx) => (
          <ToggleButton
            key={op}
            type="radio"
            variant="outline-primary"
            id={`tipoInstitucion-${idx}`}
            name="tipoInstitucion"
            value={op}
            checked={tipoInstitucion === op}
            /* Deshabilita “Privado” cuando es UTU */
            disabled={tipoCentro === 'UTU' && op === 'Privado'}
            onChange={() =>
              setFormData({ ...formData, tipoInstitucion: op, materiasPendientesSeleccionadas: {} })
            }
          >
            {op}
          </ToggleButton>
        ))}
      </ButtonGroup>


      {/* Pregunta condicional solo si eligió UTU */}
      {tipoCentro === 'UTU' && (
        <>
          <h2 className="form-title">¿Qué orientación cursaste?</h2>

          {/* 1️⃣  envolvemos en un div flex-wrap */}
          <div className="d-flex flex-wrap gap-2 mb-3 bachilleratoslabel">
            {opcionesBachillerato.map((op, idx) => (
              <ToggleButton
                key={op}
                type="radio"
                variant="outline-primary"
                id={`bachillerato-${idx}`}
                name="bachillerato"
                value={op}
                checked={!showOtherBachillerato && bachillerato === op}
                onChange={() => {
                  setShowOtherBachillerato(false);
                  setFormData({ ...formData, bachillerato: op, materiasPendientesSeleccionadas: {} });
                }}
              >
                {op}
              </ToggleButton>
            ))}
            <ToggleButton
              type="radio"
              variant="outline-primary"
              id="bachillerato-otro"
              name="bachillerato"
              value="Otro"
              checked={showOtherBachillerato}
              onChange={() => {
                setShowOtherBachillerato(true);
                setFormData({ ...formData, bachillerato: '', materiasPendientesSeleccionadas: {} });
              }}
            >
              Otro
            </ToggleButton>
          </div>
          {showOtherBachillerato && (
            <div className="mb-4">
              <label htmlFor="bachillerato-otro-texto" className="form-label">Escribí tu orientación</label>
              <input
                id="bachillerato-otro-texto"
                className="form-control"
                type="text"
                value={bachillerato}
                maxLength={30}
                placeholder="Máximo 30 caracteres"
                onChange={(event) => setFormData({
                  ...formData,
                  bachillerato: event.target.value,
                  materiasPendientesSeleccionadas: {}
                })}
                autoFocus
              />
              <small className="text-muted">{bachillerato.length}/30 caracteres</small>
            </div>
          )}
        </>
      )}

      {/* Pregunta condicional solo si eligió LICEO */}
      {tipoCentro === 'Liceo' && (
        <>
          <h2 className="form-title">¿Qué orientación cursaste en 5to?</h2>
          <div className="d-flex flex-wrap gap-2 mb-4 bachilleratoslabel">
            {opciones5to.map((op, idx) => (
              <ToggleButton
                key={op}
                type="radio"
                variant="outline-primary"
                id={`orientacion5to-${idx}`}
                name="orientacion5to"
                value={op}
                checked={orientacion5to === op}
                onChange={() => setFormData({ ...formData, orientacion5to: op, materiasPendientesSeleccionadas: {} })}
              >
                {op}
              </ToggleButton>
            ))}
          </div>

          <h2 className="form-title">¿Qué orientación cursaste en 6to?</h2>
          <div className="d-flex flex-wrap gap-2 mb-4 bachilleratoslabel">
            {opciones6to.map((op, idx) => (
              <ToggleButton
                key={op}
                type="radio"
                variant="outline-primary"
                id={`orientacion6to-${idx}`}
                name="orientacion6to"
                value={op}
                checked={orientacion6to === op}
                onChange={() => setFormData({ ...formData, orientacion6to: op, materiasPendientesSeleccionadas: {} })}
              >
                {op}
              </ToggleButton>
            ))}
          </div>
        </>
      )}




      {/* Botones siempre visibles: “Atrás” y “Aceptar” */}
      <div className="d-flex justify-content-between mt-3">
        <Button variant="secondary" onClick={prev}>
          Atrás
        </Button>
        <Button
          variant="primary"
          onClick={() => { pushDataLayer('paso7_materias'); next(); }}
          disabled={
            !tipoCentro ||
            !tipoInstitucion ||
            (tipoCentro === 'UTU' && !bachillerato.trim()) ||
            (tipoCentro === 'Liceo' && (!orientacion5to || !orientacion6to))
          }
        >
          Aceptar
        </Button>
      </div>
    </div>
  );
}
